function languageReducer(language = null, action) {
  if (action.type === 'CHANGE_LANGUAGE') {
    return action.language;
  }

  if (action.type === 'SETTINGS_UPDATE') {
    const { localization, language } = action.data;

    if (language) {
      // embedded widget's language
      return language;
    }

    if (localization && localization.language) {
      // tracking page's language
      return localization.language;
    }
  }

  return language;
}

export default languageReducer;
